import { useDisableUser, useEnableUser } from '@/modules/Users/queries';
import { useInvalidateUserQueries } from '@/shared/hooks/useInvalidateUserMutations';
import { useCallback } from 'react';

type UseToggleUserStatusProps = {
  onSettled?: () => void;
};

export const useToggleUserStatus = ({
  onSettled,
}: UseToggleUserStatusProps = {}) => {
  const { mutate: enableUser, isLoading: isLoadingEnableUser } =
    useEnableUser();
  const { mutate: disableUser, isLoading: isLoadingDisableUser } =
    useDisableUser();
  const invalidateUserQueries = useInvalidateUserQueries();
  const onChange = useCallback(
    (checked: boolean, userId: number) => {
      if (checked) {
        enableUser(userId, {
          onSuccess: invalidateUserQueries,
          onSettled,
        });
      } else {
        disableUser(userId, {
          onSuccess: invalidateUserQueries,
          onSettled,
        });
      }
    },
    [disableUser, enableUser, invalidateUserQueries, onSettled],
  );

  return {
    onChange,
    isLoading: isLoadingEnableUser || isLoadingDisableUser,
    isLoadingEnableUser,
    isLoadingDisableUser,
  };
};
